import React from 'react';

const NorthlightLogo = ({ size = 'default' }) => {
  const sizes = {
    small: { img: 28, text: 'text-base' },
    default: { img: 36, text: 'text-lg' },
    large: { img: 48, text: 'text-xl' },
  };

  const { img, text } = sizes[size] || sizes.default;

  return (
    <div className="flex items-center gap-2.5">
      <img
        src="/logo.png"
        alt="Northlight Visuals"
        style={{ width: img, height: img }}
        className="object-contain"
      />
      <div className="flex flex-col">
        <span
          className={`${text} font-bold tracking-wider leading-none font-display`}
          style={{
            background: 'linear-gradient(135deg, #ffffff 0%, #e0e7ff 50%, #c7d2fe 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          Northlight
        </span>
        <span
          className="text-[9px] font-semibold tracking-[0.3em] uppercase"
          style={{
            background: 'linear-gradient(90deg, #88a2ff 0%, #d987ff 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          Visuals
        </span>
      </div>
    </div>
  );
};

export default NorthlightLogo;
